
export function browserMobileHeightFix(cssVarName: string) {
    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty(cssVarName, `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
}
